export { default } from './generated/emojis.json';

export { default as variants } from './generated/variants.json';
